import { useAuth } from "../../login/hooks/useAuth";

export default function AdmminPage() {
  const { user } = useAuth();

  return (
    <div className="flex flex-col h-full bg-[#111111]">
      {/* Header */}

      {/* Content */}
      <div className="p-8 text-white/70">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
          <h1 className="text-2xl font-bold text-white mb-2">
            Bienvenido de nuevo, {user?.email}
          </h1>
          <p>
            Usted tiene acceso de nivel{" "}
            <span className="text-blue-400 font-mono">{user?.role}</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
